// extracted by mini-css-extract-plugin
export var card = "ThumbnailGameCard-module--card--p6V9U";
export var logo = "ThumbnailGameCard-module--logo--21Hfn";
export var description = "ThumbnailGameCard-module--description--3Scap";
export var content = "ThumbnailGameCard-module--content--1Hgy1";
export var descriptionText = "ThumbnailGameCard-module--description-text--1-YO4";
export var playGameButton = "ThumbnailGameCard-module--play-game-button--3ZPty";